// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"166":"8dc21398","186":"5b33dd96","187":"395977d3","798":"c8e6bd22","804":"f42fceeb","865":"9cca10d1"}[chunkId] + ".js";
};